document.documentElement.classList.remove('no-js');

const resetPageScroll = () => {
  if (window.location.hash) return;
  document.documentElement.scrollTop = 0;
  if (document.body) document.body.scrollTop = 0;
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
};

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

resetPageScroll();

document.addEventListener('DOMContentLoaded', () => {
  resetPageScroll();
  window.requestAnimationFrame(resetPageScroll);
  window.setTimeout(resetPageScroll, 80);
});

window.addEventListener('pageshow', () => {
  resetPageScroll();
  window.requestAnimationFrame(resetPageScroll);
  window.setTimeout(resetPageScroll, 120);
});

window.addEventListener('load', () => {
  resetPageScroll();
  window.setTimeout(resetPageScroll, 180);
});

window.addEventListener('load', () => {
  const loader = document.querySelector('[data-page-loader]');
  if (!loader) return;
  const duration = Number(getComputedStyle(loader).getPropertyValue('--loader-duration').replace('ms', '')) || 1200;
  window.setTimeout(() => loader.classList.add('is-hidden'), duration);
});

const parseCountdownTarget = (value) => {
  if (!value) return null;
  const normalized = value.trim().replace(' ', 'T');
  const parsed = new Date(normalized);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const initCountdown = (scope = document) => {
  scope.querySelectorAll('[data-countdown]').forEach((countdown) => {
    if (countdown.dataset.countdownReady === 'true') return;
    countdown.dataset.countdownReady = 'true';

    const target = parseCountdownTarget(countdown.dataset.countdownTarget);
    const daysNode = countdown.querySelector('[data-countdown-days]');
    const hoursNode = countdown.querySelector('[data-countdown-hours]');
    const minutesNode = countdown.querySelector('[data-countdown-minutes]');
    const secondsNode = countdown.querySelector('[data-countdown-seconds]');

    const setValue = (node, value) => {
      if (node) node.textContent = String(value).padStart(2, '0');
    };

    const update = () => {
      const distance = target ? Math.max(0, target.getTime() - Date.now()) : 0;
      const totalSeconds = Math.floor(distance / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      setValue(daysNode, days);
      setValue(hoursNode, hours);
      setValue(minutesNode, minutes);
      setValue(secondsNode, seconds);
    };

    update();
    countdown.dataset.countdownTimer = window.setInterval(update, 1000);
  });
};

initCountdown();

class DrawerToggle {
  constructor(button) {
    this.button = button;
    const controls = button.getAttribute('aria-controls') || '';
    this.target = document.getElementById(controls.replace(/^#/, '')) || document.querySelector(controls);
    this.closeButtons = this.target ? this.target.querySelectorAll('[data-drawer-close]') : [];
    if (!this.target) return;

    this.button.addEventListener('click', () => this.open());
    this.closeButtons.forEach((closeButton) => closeButton.addEventListener('click', () => this.close()));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });
  }

  open() {
    this.target.classList.add('is-open');
    this.button.setAttribute('aria-expanded', 'true');
    document.body.classList.add('menu-open');
  }

  close() {
    this.target.classList.remove('is-open');
    this.button.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
  }
}

class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const previous = Number(this.input.value || 1);
        const next = button.name === 'plus' ? previous + 1 : previous - 1;
        this.input.value = Math.max(Number(this.input.min || 1), next);
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }
}

if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}

document.querySelectorAll('[data-drawer-toggle]').forEach((button) => new DrawerToggle(button));

if (document.body.classList.contains('os-cursor-on')) {
  document.querySelectorAll('[data-spotlight]').forEach((section) => {
    section.addEventListener('pointermove', (event) => {
      const rect = section.getBoundingClientRect();
      section.style.setProperty('--spotlight-x', `${((event.clientX - rect.left) / rect.width) * 100}%`);
      section.style.setProperty('--spotlight-y', `${((event.clientY - rect.top) / rect.height) * 100}%`);
    });
  });
}

if (document.body.classList.contains('os-tilt-on')) {
  document.querySelectorAll('[data-tilt-card]').forEach((card) => {
    card.addEventListener('pointermove', (event) => {
      const rect = card.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width - 0.5) * 10;
      const y = ((event.clientY - rect.top) / rect.height - 0.5) * -10;
      card.style.setProperty('--tilt-x', `${x}deg`);
      card.style.setProperty('--tilt-y', `${y}deg`);
    });

    card.addEventListener('pointerleave', () => {
      card.style.setProperty('--tilt-x', '0deg');
      card.style.setProperty('--tilt-y', '0deg');
    });
  });
}

document.querySelectorAll('[data-demo-gallery]').forEach((gallery) => {
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  const previous = gallery.querySelector('[data-gallery-prev]');
  const next = gallery.querySelector('[data-gallery-next]');
  let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

  const setActive = (index) => {
    if (!slides.length) return;
    activeIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === activeIndex));
    thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === activeIndex));
  };

  previous?.addEventListener('click', () => setActive(activeIndex - 1));
  next?.addEventListener('click', () => setActive(activeIndex + 1));
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => setActive(Number(thumb.dataset.galleryThumb))));
  setActive(activeIndex);
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const slides = [...gallery.querySelectorAll('[data-product-slide]')];
  const thumbs = [...gallery.querySelectorAll('[data-product-thumb]')];
  const previous = gallery.querySelector('[data-product-prev]');
  const next = gallery.querySelector('[data-product-next]');
  const count = gallery.querySelector('[data-product-count]');
  let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

  const setActive = (index) => {
    if (!slides.length) return;
    activeIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === activeIndex));
    thumbs.forEach((thumb, thumbIndex) => {
      const isActive = thumbIndex === activeIndex;
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
    if (count) count.textContent = `${activeIndex + 1} / ${slides.length}`;
  };

  previous?.addEventListener('click', () => setActive(activeIndex - 1));
  next?.addEventListener('click', () => setActive(activeIndex + 1));
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => setActive(Number(thumb.dataset.productThumb))));
  gallery.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') setActive(activeIndex - 1);
    if (event.key === 'ArrowRight') setActive(activeIndex + 1);
  });
  setActive(activeIndex);
});

document.querySelectorAll('[data-offer]').forEach((offer) => {
  offer.querySelector('[data-offer-close]')?.addEventListener('click', () => {
    offer.hidden = true;
  });
});

const applyPortfolioFilter = (button) => {
  const tabs = button.closest('[data-filter-tabs]');
  const section = tabs?.closest('.os-portfolio');
  if (!tabs || !section) return;
  const filter = button.dataset.filter || 'all';

  tabs.querySelectorAll('[data-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
  section.querySelectorAll('[data-category]').forEach((card) => {
    const visible = filter === 'all' || card.dataset.category === filter;
    card.hidden = !visible;
  });
};

const applyServiceFilter = (button) => {
  const lab = button.closest('[data-service-lab]');
  if (!lab) return;
  const filter = button.dataset.serviceFilter || 'all';

  lab.querySelectorAll('[data-service-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
  lab.querySelectorAll('[data-service-category]').forEach((card) => {
    const category = card.dataset.serviceCategory || 'all';
    card.hidden = filter !== 'all' && category !== filter;
  });
};

const refreshServiceLabs = (scope = document) => {
  scope.querySelectorAll('[data-service-lab]').forEach((lab) => {
    const activeFilter = lab.querySelector('[data-service-filter].is-active') || lab.querySelector('[data-service-filter]');
    if (activeFilter) applyServiceFilter(activeFilter);
  });
};

document.addEventListener('click', (event) => {
  const serviceFilter = event.target.closest('[data-service-filter]');
  if (serviceFilter) {
    event.preventDefault();
    applyServiceFilter(serviceFilter);
    return;
  }

  const portfolioFilter = event.target.closest('[data-filter]');
  if (portfolioFilter) {
    event.preventDefault();
    applyPortfolioFilter(portfolioFilter);
  }
});

document.addEventListener('shopify:block:select', (event) => {
  const blockId = event.detail?.blockId;
  const selected = event.target;
  const serviceFilter = blockId
    ? document.querySelector(`[data-service-filter-block-id="${blockId}"]`)
    : selected.matches?.('[data-service-filter]')
      ? selected
      : selected.querySelector?.('[data-service-filter]');
  if (serviceFilter) applyServiceFilter(serviceFilter);
});

document.addEventListener('shopify:section:load', (event) => {
  refreshServiceLabs(event.target);
  initCountdown(event.target);
});

refreshServiceLabs();

const velnyteRoute = (path) => {
  const root = window.Shopify?.routes?.root || '/';
  return `${root}${path.replace(/^\//, '')}`;
};

const selectedBriefPaymentKey = 'velnyte:selected-brief-payment';
const checkoutAfterBriefKey = 'velnyte:checkout-after-brief';

const getStoredBriefPayment = () => {
  try {
    return JSON.parse(sessionStorage.getItem(selectedBriefPaymentKey) || 'null');
  } catch (error) {
    return null;
  }
};

const setSelectedBriefPayment = (payment) => {
  if (payment?.variantId) {
    sessionStorage.setItem(selectedBriefPaymentKey, JSON.stringify(payment));
  } else {
    sessionStorage.removeItem(selectedBriefPaymentKey);
  }
};

const hydrateIntakePayment = (payment) => {
  const hasPayment = Boolean(payment?.variantId);
  document.querySelectorAll('[data-selected-payment-product]').forEach((input) => {
    input.value = payment?.productTitle || payment?.serviceTitle || '';
  });
  document.querySelectorAll('[data-selected-payment-variant]').forEach((input) => {
    input.value = payment?.variantId || '';
  });
  document.querySelectorAll('[data-selected-payment-price]').forEach((input) => {
    input.value = payment?.price || '';
  });
  document.querySelectorAll('[data-selected-payment-label], [data-checkout-brief-note]').forEach((item) => {
    item.hidden = !hasPayment;
  });
};

const hydrateStoredBriefPayment = () => {
  const payment = getStoredBriefPayment();
  if (!payment) return;
  document.querySelectorAll('[data-selected-service]').forEach((input) => {
    input.value = payment.serviceTitle || input.value;
  });
  document.querySelectorAll('[data-selected-service-label]').forEach((label) => {
    const strong = label.querySelector('strong');
    if (strong && payment.serviceTitle) strong.textContent = payment.serviceTitle;
    label.hidden = false;
  });
  hydrateIntakePayment(payment);
};

const checkoutAfterPostedBrief = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('contact_posted') !== 'true') return;
  if (sessionStorage.getItem(checkoutAfterBriefKey) !== 'true') return;
  sessionStorage.removeItem(checkoutAfterBriefKey);
  sessionStorage.removeItem(selectedBriefPaymentKey);
  window.location.href = velnyteRoute('/checkout');
};

checkoutAfterPostedBrief();
hydrateStoredBriefPayment();

document.querySelectorAll('[data-modal-open]').forEach((button) => {
  button.addEventListener('click', () => {
    const modal = document.getElementById(button.dataset.modalOpen);
    if (!modal) return;
    document.querySelectorAll('.os-modal:not([hidden])').forEach((openModal) => {
      openModal.hidden = true;
    });
    document.body.appendChild(modal);
    modal.hidden = false;
  });
});

document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-service-cta]');
  if (!link) return;

  const modal = link.closest('.os-modal');
  if (modal) modal.hidden = true;

  const serviceTitle = link.dataset.serviceTitle || '';
  const serviceCategory = link.dataset.serviceCategory || '';
  const payment = {
    variantId: link.dataset.paymentVariantId || '',
    productTitle: link.dataset.paymentProductTitle || '',
    serviceTitle,
    price: link.dataset.paymentPrice || '',
  };
  setSelectedBriefPayment(payment);
  document.querySelectorAll('[data-selected-service]').forEach((input) => {
    input.value = serviceTitle;
  });
  document.querySelectorAll('[data-selected-service-label]').forEach((label) => {
    const strong = label.querySelector('strong');
    if (strong) strong.textContent = serviceTitle;
    label.hidden = !serviceTitle;
  });
  hydrateIntakePayment(payment);

  if (serviceCategory) {
    const projectTypeInputs = [...document.querySelectorAll('[data-project-type]')];
    const hasMatchingProjectType = projectTypeInputs.some((input) => input.dataset.projectType === serviceCategory);
    if (hasMatchingProjectType) {
      projectTypeInputs.forEach((input) => {
        input.checked = input.dataset.projectType === serviceCategory;
      });
    }
  }

  const href = link.getAttribute('href') || '';
  if (!href.startsWith('#') || href.length < 2) return;
  const target = document.querySelector(href);
  if (!target) return;

  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  if (history.pushState) history.pushState(null, '', href);
});

document.addEventListener('click', (event) => {
  const link = event.target.closest('.os-modal a[href]');
  if (!link || link.matches('[data-service-cta]')) return;

  const modal = link.closest('.os-modal');
  if (modal) modal.hidden = true;

  const href = link.getAttribute('href') || '';
  if (!href.startsWith('#') || href.length < 2) return;

  const target = document.querySelector(href);
  if (!target) return;

  event.preventDefault();
  window.requestAnimationFrame(() => {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (history.pushState) history.pushState(null, '', href);
  });
});

document.querySelectorAll('.os-intake__form').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    if (form.dataset.velnytePaymentSubmitting === 'true') return;
    const variantInput = form.querySelector('[data-selected-payment-variant]');
    const variantId = variantInput?.value?.trim();
    if (!variantId) return;

    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const note = form.querySelector('[data-checkout-brief-note]');
    const originalText = button?.textContent || '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Preparing checkout...';
    }

    const serviceTitle = form.querySelector('[data-selected-service]')?.value || '';
    const productTitle = form.querySelector('[data-selected-payment-product]')?.value || serviceTitle;
    const price = form.querySelector('[data-selected-payment-price]')?.value || '';

    try {
      const response = await fetch(velnyteRoute('/cart/add.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                'VELNYTE brief': serviceTitle || productTitle,
                'Selected price': price,
              },
            },
          ],
        }),
      });

      if (!response.ok) throw new Error('Unable to add payment product');

      sessionStorage.setItem(checkoutAfterBriefKey, 'true');
      form.dataset.velnytePaymentSubmitting = 'true';
      form.submit();
    } catch (error) {
      if (note) {
        note.hidden = false;
        note.textContent = 'Deposit checkout could not be prepared. Use the reserve deposit button on the offer card, or submit the brief without payment.';
      }
      if (button) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }
  });
});

document.querySelectorAll('[data-modal-close]').forEach((button) => {
  button.addEventListener('click', () => {
    const modal = button.closest('.os-modal');
    if (modal) modal.hidden = true;
  });
});

document.querySelectorAll('.os-modal').forEach((modal) => {
  modal.addEventListener('click', (event) => {
    if (event.target === modal) modal.hidden = true;
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.os-modal:not([hidden])').forEach((modal) => {
    modal.hidden = true;
  });
});

document.querySelectorAll('[data-transform-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    button.closest('.os-transform__card')?.classList.toggle('show-after');
  });
});

// VELNYTE product portal interactions — product template only.
document.querySelectorAll('.os-product-page--portal').forEach((portal) => {
  const gallery = portal.querySelector('[data-product-gallery]');
  const slides = gallery ? [...gallery.querySelectorAll('[data-product-slide]')] : [];
  const thumbs = gallery ? [...gallery.querySelectorAll('[data-product-thumb]')] : [];
  const worldCount = gallery?.querySelector('[data-product-world-count]');
  const expandButton = gallery?.querySelector('[data-product-expand]');
  const lightbox = portal.querySelector('[data-product-lightbox]');
  const lightboxImage = lightbox?.querySelector('[data-product-lightbox-image]');
  const lightboxCaption = lightbox?.querySelector('[data-product-lightbox-caption]');
  const lightboxClose = lightbox?.querySelector('[data-product-lightbox-close]');
  const stickyBuy = portal.querySelector('[data-product-sticky-buy]');
  const purchasePanel = portal.querySelector('.os-product__info');

  const activeIndex = () => Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

  const syncWorldCount = () => {
    const index = activeIndex();
    if (gallery) gallery.dataset.activeIndex = String(index);
    if (worldCount) worldCount.textContent = String(index + 1).padStart(2, '0');
  };

  if (slides.length) {
    const observer = new MutationObserver(syncWorldCount);
    slides.forEach((slide) => observer.observe(slide, { attributes: true, attributeFilter: ['class'] }));
    syncWorldCount();
  }

  portal.querySelectorAll('[data-product-jump]').forEach((button) => {
    button.addEventListener('click', () => {
      const index = Number(button.dataset.productJump || 0);
      thumbs[index]?.click();
      gallery?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  let touchStartX = 0;
  let touchStartY = 0;

  gallery?.addEventListener('touchstart', (event) => {
    const touch = event.touches[0];
    if (!touch) return;
    touchStartX = touch.clientX;
    touchStartY = touch.clientY;
  }, { passive: true });

  gallery?.addEventListener('touchend', (event) => {
    const touch = event.changedTouches[0];
    if (!touch || !slides.length) return;
    const deltaX = touch.clientX - touchStartX;
    const deltaY = touch.clientY - touchStartY;
    if (Math.abs(deltaX) < 54 || Math.abs(deltaX) < Math.abs(deltaY)) return;
    const index = activeIndex();
    const targetIndex = deltaX < 0
      ? (index + 1) % slides.length
      : (index - 1 + slides.length) % slides.length;
    thumbs[targetIndex]?.click();
  }, { passive: true });

  const closeLightbox = () => {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.body.classList.remove('os-product-lightbox-open');
    expandButton?.focus();
  };

  expandButton?.addEventListener('click', () => {
    const slide = slides[activeIndex()];
    const image = slide?.querySelector('img');
    if (!lightbox || !lightboxImage || !image) return;
    lightboxImage.src = image.currentSrc || image.src;
    lightboxImage.alt = image.alt || '';
    if (lightboxCaption) lightboxCaption.textContent = image.alt || portal.querySelector('h1')?.textContent || '';
    lightbox.hidden = false;
    document.body.classList.add('os-product-lightbox-open');
    lightboxClose?.focus();
  });

  lightboxClose?.addEventListener('click', closeLightbox);
  lightbox?.addEventListener('click', (event) => {
    if (event.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && lightbox && !lightbox.hidden) closeLightbox();
  });

  if (stickyBuy && purchasePanel && 'IntersectionObserver' in window) {
    const stickyObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      stickyBuy.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > 220);
    }, { threshold: 0.08 });
    stickyObserver.observe(purchasePanel);
  }
});

// VELNYTE demo password copy helper.
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-demo-password]');
  if (!button) return;

  const password = button.dataset.demoPassword;
  const status = button.querySelector('span');
  if (!password) return;

  try {
    await navigator.clipboard.writeText(password);
    if (status) {
      const original = status.textContent;
      status.textContent = 'Copied';
      window.setTimeout(() => { status.textContent = original; }, 1600);
    }
  } catch (error) {
    if (status) status.textContent = 'Select password';
  }
});

// VELNYTE floating navigation: keep only one visual menu open and close it cleanly.
document.addEventListener('click', (event) => {
  const activeDetails = event.target.closest('.header__nav details');
  const clickedSummary = event.target.closest('.header__nav summary');

  if (clickedSummary && activeDetails) {
    document.querySelectorAll('.header__nav details[open]').forEach((details) => {
      if (details !== activeDetails) details.removeAttribute('open');
    });
    return;
  }

  if (!event.target.closest('.header__nav')) {
    document.querySelectorAll('.header__nav details[open]').forEach((details) => details.removeAttribute('open'));
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.header__nav details[open]').forEach((details) => details.removeAttribute('open'));
});
